// Container
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Management
const OrderTrackingImportList = () => import('@/modules/order_tracking/views/OrderTrackingImportList')


var routes = [
    {
        path: '/order-tracking/import',
        redirect: '/order-tracking/import',
        name: 'OrderTrackingImport',
        component: DefaultContainer,
        children: [
            {
				path: '/order-tracking/import',
                name: 'OrderTrackingImportList',
                component: OrderTrackingImportList,
                meta: {
                    requiresAuth: true,
                    permission: false,
                },
            },
        ]
    },
];


export default routes;
